var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "ul",
    { staticClass: "nav nav-set nav-set-tri", class: _vm.$style.tablist },
    _vm._l(_vm.tabs, function (tab) {
      return _c(
        "li",
        {
          key: tab.id,
          class: [
            _vm.$style.item,
            tab.id === _vm.currentTab && _vm.$style.active,
          ],
          on: {
            click: function ($event) {
              return _vm.handleTabClick(tab.id)
            },
          },
        },
        [
          _c("button", { class: _vm.$style.button }, [
            _vm._v(" " + _vm._s(tab.name) + " "),
          ]),
        ]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }